import ConversationMessageCompositionContent from 'models/composition/conversation_message_composition_content';
import CreateComposition from 'actions/composition/lib/create_composition';
import { MessageChannelType } from 'models/conversation_message';

class CreateFacebookCommentReplyComposition extends CreateComposition {
  constructor(context) {
    super(context, ConversationMessageCompositionContent);
  }

  _createContent({ conversationItem }) {
    const companyEndpoint = this._findCommentedOnPage(conversationItem);

    if (!companyEndpoint) {
      return undefined;
    }

    return new ConversationMessageCompositionContent({
      channel: MessageChannelType.FB_COMMENT,
      channelDisplayTitle: 'Facebook Comment',
      companyAddress: companyEndpoint.address,
      companyDisplayName: pageName(companyEndpoint),
      customerAddress: conversationItem.content.customerAddress,
      customerDisplayName: conversationItem.content.formatCustomerAddress(),
      meta: {
        parentCommentId: conversationItem.content.externalId,
        postId: conversationItem.content.getPostId(),
      },
    });
  }

  // A reply is public and threads under one comment, so an open reply to a
  // different comment must never be reused for this one.
  _isSameCompositionType({ conversationItem }, composition) {
    return (
      composition.content instanceof this.contentClass &&
      composition.content.channel === MessageChannelType.FB_COMMENT &&
      composition.content.meta?.parentCommentId === conversationItem.content.externalId
    );
  }

  _canCreateComposition() {
    const appFeatures = this.context.stores.appFeatures.get();
    if (!appFeatures.isEnabled('conversation:outbound') || !appFeatures.isEnabled('facebookCommentReplies')) {
      return false;
    }

    const channelConfiguration = this.context.stores.channelConfiguration.get();
    return !!channelConfiguration && channelConfiguration.companyFacebookCommentAddresses().length > 0;
  }

  // No fallback Page: replying from any other Page would post under the wrong
  // brand, so if this one has been disconnected no composer opens.
  _findCommentedOnPage(conversationItem) {
    const channelConfiguration = this.context.stores.channelConfiguration.get();
    const endpoints = channelConfiguration
      ? channelConfiguration.getEndpointsOfType(MessageChannelType.FB_COMMENT)
      : [];

    return endpoints.find(endpoint => endpoint.address === conversationItem.content.companyAddress);
  }
}

function pageName(endpoint) {
  return endpoint.displayName || endpoint.name || endpoint.address;
}

export default CreateFacebookCommentReplyComposition;
